export const page9 = {
  "name": "page9",
  "title": "The way you feel",
  "description": "To what extent do you agree with the following sentences?",
  "elements": [
    {
      "type": "rating",
      "name": "purpose",
      "title": "Sometimes I have a sense of lack of purpose or meaning in life.",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Strongly disagree"
        },
        {
          "value": 2,
          "text": "Disagree"
        },
        {
          "value": 3,
          "text": "Neutral"
        },
        {
          "value": 4,
          "text": "Agree"
        },
        {
          "value": 5,
          "text": "Strongly agree"
        }
      ]
    },
    {
      "type": "rating",
      "name": "care_for_self",
      "title": "I fear that I do not take good enough care of myself.",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Strongly disagree"
        },
        {
          "value": 2,
          "text": "Disagree"
        },
        {
          "value": 3,
          "text": "Neutral"
        },
        {
          "value": 4,
          "text": "Agree"
        },
        {
          "value": 5,
          "text": "Strongly agree"
        }
      ]
    },
    {
      "type": "rating",
      "name": "importance_of_improvement",
      "title": "I attach great importance to improving elements of my life.",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Strongly disagree"
        },
        {
          "value": 2,
          "text": "Disagree"
        },
        {
          "value": 3,
          "text": "Neutral"
        },
        {
          "value": 4,
          "text": "Agree"
        },
        {
          "value": 5,
          "text": "Strongly agree"
        }
      ]
    },
    {
      "type": "rating",
      "name": "support",
      "title": "I know what to do or who to turn to when I need support.",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Strongly disagree"
        },
        {
          "value": 2,
          "text": "Disagree"
        },
        {
          "value": 3,
          "text": "Neutral"
        },
        {
          "value": 4,
          "text": "Agree"
        },
        {
          "value": 5,
          "text": "Strongly agree"
        }
      ]
    }
  ]
};